import { memo } from 'react'
import { themed, type IconProps } from '@tamagui/helpers-icon'
import { Svg, Path, SvgProps } from 'react-native-svg'
import { size as globalSize } from '../../theme/tokens'

const Icon = (propsBase: IconProps) => {
  const { color, size = globalSize.$3, ...otherProps } = propsBase as SvgProps & { size: number }

  return (
    <Svg width={size} height={size} viewBox="0 0 32 32" fill={color} {...otherProps}>
      <Path d="M16.3 16.5C10.5 16.5 6 19.4 6 23.1V27.4C6 28 6.4 28.4 7 28.4C7.6 28.4 8 28 8 27.4V23.1C8 22.1 8.5 21.2 9.5 20.5C9.6 20.5 9.6 20.5 9.7 20.4C11.3 19.2 13.8 18.4 16.4 18.4C19 18.4 21.5 19.1 23.1 20.4C23.1 20.4 23.2 20.5 23.3 20.5C24.2 21.2 24.8 22.1 24.8 23.1V27.4C24.8 28 25.2 28.4 25.8 28.4C26.4 28.4 26.8 28 26.8 27.4V23.1C26.6 19.4 22.1 16.5 16.3 16.5Z" />
      <Path d="M15.9998 18.5C11.6998 18.5 8.2998 15 8.2998 10.8C8.2998 6.6 11.6998 3 15.9998 3C20.2998 3 23.6998 6.5 23.6998 10.7C23.6998 14.9 20.2998 18.5 15.9998 18.5ZM15.9998 5C12.7998 5 10.2998 7.6 10.2998 10.7C10.2998 13.8 12.8998 16.4 15.9998 16.4C19.0998 16.4 21.6998 13.8 21.6998 10.7C21.6998 7.6 19.1998 5 15.9998 5Z" />
      <Path d="M16.0002 14.8001C15.2002 14.8001 14.4002 14.6001 13.7002 14.1001C13.5002 13.9001 13.4002 13.6001 13.6002 13.4001C13.8002 13.2001 14.1002 13.1001 14.3002 13.3001C15.3002 14.0001 16.7002 14.0001 17.8002 13.3001C18.0002 13.1001 18.3002 13.2001 18.5002 13.4001C18.7002 13.6001 18.6002 13.9001 18.4002 14.1001C17.7002 14.5001 16.8002 14.8001 16.0002 14.8001Z" />
    </Svg>
  )
}

Icon.displayName = 'Member'

export const Member = memo<IconProps>(themed(Icon))
